<template>
  <div class="view match">
  <div class="prequiz">
    <div class="question-card">
      <div class="progress label">1 to 25</div>
      <p class="feedback-heading" >{{ feedbackTitle }}</p>
      <div class="heading">
        <div class="scores-container">
          <div class="score-container">{{time}}</div>
          <div class="best-container" style="background-color: #00a84d;">{{best_time}}</div>
        </div>
      </div>
      <div class="game-container" id="game-container">
        <div id="timer" v-if="!showBoard">{{counter}}</div>
        <div id="tile" v-if="showBoard" @click="clickTile(num_arr,index)" v-for="(num_arr,index) in num_array">
          <transition name="fade">
            <p>{{num_arr}}</p>
          </transition>
        </div>
      </div>
    </div>
  </div>
    <transition v-if="isModalVisible" name="modal-fade">
      <div class="modal-backdrop">
        <div class="modal"
             role="dialog"
             aria-labelledby="modalTitle"
             aria-describedby="modalDescription"
        >
          <section
                  class="modal-body"
                  id="modalDescription"
          >
            <slot name="body">
              🎉 Hurray! New High Score 🎉
            </slot>
          </section>
        </div>
      </div>
    </transition>
    <div class="container" v-if="!game">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>
  </div>

</template>
<script>
import axios from "axios";
export default {
  components: {

  },
  data() {
    return {
      feedbackTitle:"Tap 1 to 25 as quickly as you can!!",
      num_array: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25],
      current_num:1,
      next_num:"",
      counter:3,
      best_time:'0',
      game:true,
      time:'0.000',
      show: true,
      showBoard:false,
      best_score:Number.MAX_SAFE_INTEGER,
      is_playing:false,
      tick: new Audio('https://dl.getdropbox.com/s/kgqqnei0yhv3r8n/219069__annabloom__click1.wav'),
      timeBegan: null,
      timeStopped: null,
      stoppedDuration: 0,
      started: null,
      isModalVisible:false,
      running: false
    }
  },//DATA
  mounted()
  {
    this.startGame();
    const api = "https://create.tunitrivia.com/api/challenge/trivia/game/1to50/get/highscore";
    let data =  {
      'trivia_id': this.$store.state.matchSlug,
      'isp':this.$store.state.isp
    };
    const qs = require('qs')
    axios({
      method: 'post',
      url: api,
      data: qs.stringify(data),
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
      }
    }).then(response => {
      this.best_time = response.data.data;
    })
  },
  methods: {
    start() {
      if(this.running) return;

      if (this.timeBegan === null) {
        this.reset();
        this.timeBegan = new Date();
      }

      if (this.timeStopped !== null) {
        this.stoppedDuration += (new Date() - this.timeStopped);
      }

      this.started = setInterval(this.clockRunning, 10);
      this.running = true;
    },
    stop() {
      this.running = false;
      this.timeStopped = new Date();
      clearInterval(this.started);
    },
    reset() {
      this.running = false;
      clearInterval(this.started);
      this.stoppedDuration = 0;
      this.timeBegan = null;
      this.timeStopped = null;
      this.time = "00.000";
    },
    clockRunning(){
      let currentTime = new Date()
              , timeElapsed = new Date(currentTime - this.timeBegan - this.stoppedDuration)
              , hour = timeElapsed.getUTCHours()
              , min = timeElapsed.getUTCMinutes()
              , sec = timeElapsed.getUTCSeconds()
              , ms = timeElapsed.getUTCMilliseconds();

      this.time =
              this.zeroPrefix(sec, 2) + "." +
              this.zeroPrefix(ms, 3);
    },
    zeroPrefix(num, digit) {
      let zero = '';
      for(let i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    },
    advance() {
      if (this.game.draw)
      {
        this.$store.commit('addScore',10);
      }
      if (this.game.winner ==='X')
      {
        this.$store.commit('addScore',30);
      }
      // Proceed if less than 10 rounds
      if (this.$store.state.round <= (this.$store.state.questions.length-2)) {
        this.$store.commit('pauseGame');
        //this.playerClickedCard = false;
        this.$store.commit('playerClickedCard',false);
        //this.resultsView = false;
        this.$store.commit('setResults',false);
        //this.timerCount = 30;
        setTimeout(() => {
          this.$store.commit('setIsOnBreak');
        }, 1500)
      }else
      {
        //this.$store.commit('isGameOver');
        setTimeout(() => {
          this.$store.commit('setIsOnBreak');
        }, 1500)

      }
    },
    startGame() {
      this.is_playing = true;
      let context = this;
      let timer = setInterval(function() {
        //console.log(context.is_playing)
        if (context.is_playing) {
          context.counter -=1;
          if (context.counter <= 0) {
            context.shuffle(context.num_array);
            context.showBoard=true;
            clearInterval(timer);
          }
        } else {
          // countdown timer has to be reset.
          clearInterval(timer);
          context.counter = 3;

        }
      }, 1000);
    },
    shuffle(a) {
      let j, x, i;
      for (i = a.length; i; i -= 1) {
        j = Math.floor(Math.random() * i);
        x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
      }
    },
    clickTile(tile,index) {
      if (this.current_num === 1)
      {
        this.start();
      }
      if (tile === this.current_num) {
        this.current_num +=1;
        this.$set(this.num_array, index, '');
        if (this.current_num > 25) {
          this.stop();
          this.score();
          if (Number(this.best_time) >= Number(this.time))
          {
            this.best_time = this.time;
            this.isModalVisible = true;
          }
          setTimeout(() => {
            this.isModalVisible = false;
            this.game = false;
            this.advance();
          }, 2500)

        }

      } else {
        // we can discuss and add a possible penalty for clicking a wrong tile.
      }
    },
    score()
    {
      const api = "https://create.tunitrivia.com/api/challenge/trivia/game/1to50/update/highscore";
      let data =  {
        'trivia_id': this.$store.state.matchSlug,
        'isp':this.$store.state.isp,
        'score':Math.round(this.time)
      };
      const qs = require('qs')
      axios({
        method: 'post',
        url: api,
        data: qs.stringify(data),
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
        }
      }).then(response => {
        return true;
      })
    }
  }
};
</script>
<style lang="css" scoped>
  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  html, body {
    margin: 0;
    padding: 0;
    background: #faf8ef;
    color: #faf8ef;
    font-size: 18px;
  }

  body {
    margin: 20px 0;
  }

  div {
    display: block;
  }

  .container {
    width: 600px;
    margin: 0px auto;
  }

  .heading:after {
    content: "";
    display: block;
    clear: both;
  }

  h1.title {
    font-size: 80px;
    font-weight: bold;
    margin: 0;
    display: block;
    float: left;
  }

  .scores-container {
    width: 100%;
    text-align: center;
  }

  .score-container, .best-container {
    position: relative;
    display: inline-block;
    background: #fbb03b;
    padding: 15px;
    font-size: 15px;
    font-weight: bold;
    border-radius: 3px;
    color: white;
    margin:0 10px 0 10px;
    text-align: center;
    width: 120px;
  }

  .score-container:after, .best-container:after {
    position: absolute;
    width: 100%;
    top: 5px;
    left: 0;
    text-transform: uppercase;
    font-size: 13px;
    line-height: 13px;
    text-align: center;
    color: #eee4da;
  }

  .score-container:after {
    content: "Time";
  }

  .best-container:after {
    content: "Best Time";
  }

  .above-game:after {
    content: "";
    display: block;
    clear: both;
  }

  .game-intro {
    float: left;
    line-height: 42px;
    margin-bottom: 0;
  }

  .restart-button {
    display: inline-block;
    background: #002152;
    border-radius: 3px;
    padding: 0 20px;
    text-decoration: none;
    color: #f9f6f2;
    height: 40px;
    line-height: 42px;
    display: block;
    text-align: center;
    float: right;
    cursor: pointer;
  }

  p {
    margin-top: 0;
    margin-bottom: 10px;
    line-height: 1.65;
  }

  a {
    font-weight: bold;
    cursor: pointer;
  }

  .above-game a:hover {
    color: yellow;
  }

  #game-container {
    background: #fff;
    border-radius: 10px;
    width: 570px;
    height: 570px;
    padding: 20px;
    margin: 15px auto;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    touch-action: none;
  }

  #tile {
    background: #002152;
    border-radius: 5px;
    width: 100px;
    height: 65px;
    float: left;
    margin: 3px 2px 2px 3px;
    padding: 5px;
    font-size: 35px;
    color: #ffffff;
    cursor: pointer;
    text-align: center;
  }

  #start-button {
    background: #002152;
    border-radius: 20px;
    vertical-align: middle;
    width: 350px;
    height: 100px;
    font-size: 50px;
    padding: 15px;
    color: #ffffff;
    cursor: pointer;
    text-align: center;
    margin: 190px auto;
  }

  #timer {
    font-size: 150px;
    text-align: center;
    vertical-align: middle;
    color: #fbb03b;
    margin: 150px auto;
  }

  #game-over {
    font-size: 50px;
    text-align: center;
    vertical-align: middle;
    color: white;
    margin: 50px auto;
  }

  #restart-button {
    background: #002152;
    border-radius: 20px;
    vertical-align: middle;
    width: 350px;
    height: 100px;
    font-size: 50px;
    padding: 15px;
    color: #ffffff;
    cursor: pointer;
    text-align: center;
    margin: 50px auto;
  }

  .footer {
    text-align: center;
  }

  #fb iframe {
    width: 90px;
    height: 30px;
  }


  @media only screen and (max-device-width: 480px) {
    html, body {
      margin: 0;
      padding: 0;
      background: #faf8ef;
      color: #faf8ef;
      font-size: 30px;
    }

    body {
      margin: 40px 0;
    }

    div {
      display: block;
    }

    .container {
      width: 800px;
      margin: 0px auto;
    }

    .heading:after {
      content: "";
      display: block;
      clear: both;
    }

    h1.title {
      font-size: 100px;
      font-weight: bold;
      margin: 0;
      display: block;
      float: left;
    }

    .scores-container {
      width: 100%;
      text-align: center;
    }

    .score-container, .best-container {
      position: relative;
      display: inline-block;
      background: #fbb03b;
      padding: 15px;
      font-size: 15px;
      font-weight: bold;
      border-radius: 3px;
      color: white;
      margin: 1px 10px 1px 10px;
      text-align: center;
      width: 120px;
    }

    .score-container:after, .best-container:after {
      position: absolute;
      width: 100%;
      top: 1px;
      left: 0;
      text-transform: uppercase;
      font-size: 12px;
      line-height: 12px;
      text-align: center;
      color: #eee4da;
    }

    .score-container:after {
      content: "Time";
    }

    .best-container:after {
      content: "Best Time";
    }

    .above-game:after {
      content: "";
      display: block;
      clear: both;
    }

    .game-intro {
      float: left;
      width: 55%;
      line-height: 45px;
      margin-bottom: 0;
      margin-top: 20px;
      font-size: 37px;
    }

    .restart-button {
      display: inline-block;
      background: #002152;
      border-radius: 5px;
      padding: 20px;
      text-decoration: none;
      color: #f9f6f2;
      width: 42%;
      height: 90px;
      line-height: 42px;
      display: block;
      text-align: center;
      float: right;
      cursor: pointer;
      margin-top: 20px;
      font-size: 40px;
    }

    p {
      margin-top: 0;
      margin-bottom: 10px;
      line-height: 1.65;
    }

    a {
      font-weight: bold;
      cursor: pointer;
    }

    .above-game a:hover {
      color: yellow;
    }

    #game-container {
      border-radius: 20px;
      width: 100%;
      height: 570px;
      padding: 20px;
      /* margin: 60px auto; */
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      touch-action: none;
    }

    #tile {
      background: #002152;
      border-radius: 10px;
      width: 18%;
      height: 12%;
      float: left;
      margin: 4px 2px 2px 4px;
      padding: 5px;
      font-size: 33px;
      color: #ffffff;
      cursor: pointer;
      text-align: center;
    }

    #start-button {
      background: #002152;
      border-radius: 20px;
      vertical-align: middle;
      width: 500px;
      height: 120px;
      font-size: 60px;
      padding: 15px;
      color: #ffffff;
      cursor: pointer;
      text-align: center;
      margin: 260px auto;
    }

    #timer {
      font-size: 80px;
      text-align: center;
      vertical-align: middle;
      color: #fbb03b;
      margin: 150px auto;
    }

    #game-over {
      font-size: 80px;
      text-align: center;
      vertical-align: middle;
      color: white;
      margin: 70px auto;
    }

    #restart-button {
      background: #002152;
      border-radius: 20px;
      vertical-align: middle;
      width: 450px;
      height: 130px;
      font-size: 70px;
      padding: 15px;
      color: #ffffff;
      cursor: pointer;
      text-align: center;
      margin: 50px auto;
    }

    #fb iframe {
      margin: 50px;
      transform: scale(2.5);
      -ms-transform: scale(2.5);
      -webkit-transform: scale(2.5);
      -o-transform: scale(2.5);
      -moz-transform: scale(2.5);
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  html, body {
    margin: 0;
    width: 100%;
    height: 100%;
    background-color: #03002E;
  }

  body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  * {
    box-sizing: border-box;
  }

  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 999;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    animation: rotation 1s infinite;
  }

  .container .shape {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 5px;
  }

  .container .shape.shape-1 {
    left: 0;
    background-color: #4285F4;
  }

  .container .shape.shape-2 {
    right: 0;
    background-color: #34A853;
  }

  .container .shape.shape-3 {
    bottom: 0;
    background-color: #FBBC05;
  }

  .container .shape.shape-4 {
    bottom: 0;
    right: 0;
    background-color: #EA4335;
  }

  .container .shape-1 {
    animation: shape1 0.5s infinite alternate;
  }

  .container .shape-2 {
    animation: shape2 0.5s infinite alternate;
  }

  .container .shape-3 {
    animation: shape3 0.5s infinite alternate;
  }

  .container .shape-4 {
    animation: shape4 0.5s infinite alternate;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  @keyframes shape1 {
    from {
      transform: translate(0, 0);
    }

    to {
      transform: translate(20px, 20px);
    }
  }

  @keyframes shape2 {
    from {
      transform: translate(0, 0);
    }

    to {
      transform: translate(-20px, 20px);
    }
  }

  @keyframes shape3 {
    from {
      transform: translate(0, 0);
    }

    to {
      transform: translate(20px, -20px);
    }
  }

  @keyframes shape4 {
    from {
      transform: translate(0, 0);
    }

    to {
      transform: translate(-20px, -20px);
    }
  }
</style>
<style lang="sass" scoped>
  .modal-backdrop
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    background-color: rgba(0, 0, 0, 0.3)
    display: flex
    justify-content: center
    align-items: center

    .modal
      background: #FFFFFF
      box-shadow: 2px 2px 20px 1px
      overflow-x: auto
      display: flex
      border-bottom: 4px solid #008F41
      width: 80%
      text-align: center
      justify-content: center
      min-height: 130px
      flex-direction: column

    .modal-header, .modal-footer
      padding: 15px
      display: flex

    .modal-header
      border-bottom: 1px solid #eeeeee
      color: #4AAE9B
      justify-content: space-between

    .modal-footer
      border-top: 1px solid #eeeeee
      justify-content: flex-end

    .modal-body
      position: relative
      padding: 20px 10px

    .btn-close
      border: none
      font-size: 20px
      padding: 20px
      cursor: pointer
      font-weight: bold
      color: #4AAE9B
      background: transparent

    .btn-green
      color: white
      background: #4AAE9B
      border: 1px solid #4AAE9B
      border-radius: 2px
</style>
